import Button from "../../components/button/Button";
import { ChangeEvent, useEffect, useState } from "react";
import { useOrderInfoContext } from "@src/app/order-info-context";
import { useOrderFlowContext } from "@src/app/order-flow-context";

export interface UploadPhotosModel {
  type: string;
  title: string;
  text: string;
  placeholder: string;
  photos: string[];
  skip: string;
  ctaText: string;
  placeholderImageSrc: string;
  addImageIconSrc: string;
  errorMessageFileType: string;
  errorMessageFileSize: string;
}

interface Props {
  data: UploadPhotosModel;
}

const UploadPhotos = ({ data }: Props) => {

  const { uploadPhotos, setUploadPhotos } = useOrderInfoContext();
  const [photos, setPhotos] = useState(uploadPhotos || []);

  useEffect(()=> {
    const dataPhotos = photos?.map(photo => photo);
    setUploadPhotos!(dataPhotos);
  }, [photos]);

  const convertFileBase64 = (file: File) => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (ev) => (typeof reader.result === "string" ? resolve(reader.result) : reject("Unexpected type received from FileReader"));
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const validateImage = (file: File) => {
    const fileSize = file.size;
    if (Math.round((fileSize / 1024)) >= 4096) {
      alert(data?.errorMessageFileSize);
      return;
    }

    const pattern = /image-*/;
    const fileType = file.type;
    if(!fileType.match(pattern)) {
      alert(data?.errorMessageFileType);
      return;
    }

    return true;
  }

  const handleUploadPhoto = (e: ChangeEvent<HTMLInputElement>): void => {
    const file: any = e?.target?.files?.[0];
    if(!validateImage(file)) return; 
    
    convertFileBase64(file).then((result) => {
      setPhotos([...photos, result]);      
    });
  };

  const { handleContinue } = useOrderFlowContext();

  return (
    <div className="fm-o-upload-photos">
      <div className="fm-o-upload-photos__content">
        <h2 className="fm-o-upload-photos__title">{data.title}</h2>
        <div className="fm-o-upload-photos__subtitle">{data.text}</div>
        <div className="fm-o-upload-photos__upload-container">
          {photos.length === 0 && (
            <div className="fm-o-upload-photos__none-image">
              <label>
                <img className="fm-o-upload-photos__placeholder-image" src={data.placeholderImageSrc} alt="" />
                <p className="fm-o-upload-photos__placeholder-text">{data?.placeholder}</p>
                <input type="file" accept="image/*" className="hidden" onChange={handleUploadPhoto} />
              </label>
            </div>
          )}
          {photos.length > 0 && (
            <div className="fm-o-upload-photos__add-image">
              {photos.length < 5 && (
                <div className="fm-o-upload-photos__add-image-icon">
                  <label>
                    <img src={data.addImageIconSrc} alt="" />
                    <input type="file" accept="image/*" className="hidden" onChange={handleUploadPhoto} />
                  </label>
                </div>
              )}
              {photos.map((photo) => (
                <img src={photo} alt="" />
              ))}
            </div>
          )}
        </div>
        {photos.length > 0 && <Button text={data?.ctaText} onClick={handleContinue} mainClass="fm-o-upload-photos__setup-btn" styleModifier={["fm-a-button--blue"]}  />}
        {photos.length === 0 && <Button text={data?.skip} onClick={handleContinue} mainClass="fm-o-upload-photos__setup-btn" />}
      </div>
    </div>
  );
};

export default UploadPhotos;
